import { number } from "yup";
import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"
import { Interface } from "readline";

export interface IDadosRetornoMediaTimes {
    dado: IListaDadosMediaTimes[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosMediaTimes {
    codigo: number;
    nome: string;
    caminho_Logo: string;
    logo: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fgM_Informativo: number;
    fgA_Informativo: number;
    ftM_Informativo: number;
    ftA_Informativo: number;
    threepM_Informativo: number;
    threepA_Informativo: number;
    setimo_Homem: boolean;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
}

export interface IDadosRetornoMediaJogadores {
    dado: IListaDadosMediaJogadores[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosMediaJogadores {
    codigo?: number;
    codigo_NBA?: number;
    nome: string;
    foto?: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem?: number;
    oreb?: number;
    pf?: number;
    pts?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
    color_Ast: string | null;
    color_Blk: string | null;
    color_Dreb: string | null;
    color_Fga: string | null;
    color_Fgm: string | null;
    color_Fgmp: string | null;
    color_Fta: string | null;
    color_Ftm: string | null;
    color_Ftmp: string | null;
    color_Min: string | null;
    color_Mplu: string | null;
    color_Ordem: string | null;
    color_Oreb: string | null;
    color_Pf: string | null;
    color_Pts: string | null;
    color_Reb: string | null;
    color_Stl: string | null;
    color_Threepa: string | null;
    color_Threepm: string | null;
    color_Threepmp: string | null;
    color_To: string | null;
    color_Fte: string | null;
    color_Fge: string | null;
    color_Threepe: string | null;
    color_Stocks: string | null;
    peso_Total_Jogador?: number;
    peso_Minutos_Jogador?: number;
    posicao_Liga_1?: string;
    posicao_Liga_2?: string;
    posicao_Liga_3?: string;
    posicao_Original?: string;
    quantidade_Jogos?: number;
    fgM_Informativo?: number;
    fgA_Informativo?: number;
    ftM_Informativo?: number;
    ftA_Informativo?: number;
    threepM_Informativo?: number;
    threepA_Informativo?: number;
    setimo_Homem?: boolean;

}

export interface IDadosRetornoMeusJogadores {
    dado: IListaDadosMeusJogadores[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosMeusJogadores {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min: number;
    mplu?: number
    ordem: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fgM_Informativo: number;
    fgA_Informativo: number;
    ftM_Informativo: number;
    ftA_Informativo: number;
    threepM_Informativo: number;
    threepA_Informativo: number;
    setimo_Homem: boolean;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;

}

export interface IDadosRetornoTimeVersus {
    dado: IDadosRetornoFranquiaVersus;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoFranquiaVersus {
    franquia: IDadosTimeVersus;
    franquias_Liga: IDadosTimeVersus[];
    classificacao_Franquia: IDadosTimeVersus;

}

export interface IDadosClassificacaoFranquia {
    codigo?: number;
    codigo_NBA?: number;
    nome?: string;
    foto?: string;
    classificacao_AST?: number;
    classificacao_Blk?: number;
    classificacao_Dreb?: number;
    classificacao_Fga?: number;
    classificacao_Fgm?: number;
    classificacao_Fgmp?: number;
    classificacao_Fta?: number;
    classificacao_Ftm?: number;
    classificacao_Ftmp?: number;
    classificacao_Mplu?: number
    classificacao_Oreb?: number;
    classificacao_Pf?: number;
    classificacao_Pts?: number;
    classificacao_Reb?: number;
    classificacao_Stl?: number;
    classificacao_Threepa?: number;
    classificacao_Threepm?: number;
    classificacao_Threepmp?: number;
    classificacao_To?: number;
}

export interface IDadosTimeVersus {
    codigo?: number;
    codigo_NBA?: number;
    nome?: string;
    foto?: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem?: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fgM_Informativo?: number;
    fgA_Informativo?: number;
    ftM_Informativo?: number;
    ftA_Informativo?: number;
    threepM_Informativo?: number;
    threepA_Informativo?: number;
    setimo_Homem?: boolean;
    placar?: string;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
}

export interface IListagemMeusJogadores {
    codigo: number;
    jogador: string;
    foto: string;
    valor: string;
    periodo: string;
}

export interface IDadosRetornoHistoricoConfrontosFranquias {
    dado: IListaDadosHistoricoConfrontos[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoHistoricoConfrontos {
    dado: IDadosRetornoHistorico;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoHistorico {

    historico_Confronto: IListaDadosHistoricoConfrontos[];
    detalhes_Historico_Confronto: IListaDadosHistoricoConfrontos[];
}

export interface IListaDadosHistoricoConfrontos {
    codigo: number;
    codigo_Franquia_1: number;
    codigo_Franquia_2: number;
    nome_Franquia1: string;
    nome_Franquia2: string;
    logo_Franquia_1: string;
    logo_Franquia_2: string;
    caminho_Logo_Franquia_1: string;
    caminho_Logo_Franquia_2: string;
    nome_Usuario_Franquia1: string;
    foto_Usuario_Franquia1: string;
    codigo_Usuario_Franquia1: number;
    codigo_Usuario_Franquia2: number;
    nome_Usuario_Franquia2: string;
    foto_Usuario_Franquia2: string;
    caminho_Foto_Usuario_Franquia1: string;
    caminho_Foto_Usuario_Franquia2: string;
    ano: string;
    franquia_1: string;
    franquia_2: string;
    vitoria_Franquia1: number;
    vitoria_Franquia2: number;
    empate: number;
    codigo_Temporada: number;
    descricao_Temporada: string;
    codigo_Liga: number;
    nome_Liga: string;
    logo_Liga: string;
    caminho_Logo_Liga: string;
}



export interface IDadosRetornoTrofeusGM {
    dado: IListaDadosTrofeusGM[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


export interface IListaDadosTrofeusGM {
    codigo_Usuario: number;
    nome_Usuario: string;
    posicao: number;
    foto_Usuario: string;
    quantidade_Titulo_Liga: number;
    quantidade_Titulo_Conferencia: number;
    quantidade_Titulo_Divisao: number;
    quantidade_Titulo_Copinha: number;

}

export interface IDadosRetornoGaleriaGM {
    dado: IListaDadosGaleriaGM;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosGaleriaGM {
    codigo: number;
    nome: string;
    foto: string;
    historico_Liga: IDadosHistoricoVitorias[];
    historico_Conferencia: IDadosHistoricoVitorias[];
    historico_Divisao: IDadosHistoricoVitorias[];
    historico_Copinha: IDadosHistoricoVitorias[];

}

export interface IDadosHistoricoVitorias {
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    descricao_Temporada: string;
    nome_Franquia: string;
    nome_Liga: string;
    foto_Usuario: string;
    logo_Franquia: string;
    logo_Liga: string;
}

export interface IDadosRetornoTrofeusLiga {
    dado: IListaDadosObjetoTrofeusLiga;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosObjetoTrofeusLiga {
    codigo: number;
    nome: string;
    logo: string
    caminho_Logo: string
    classificacao_Geral: IDadosClassificacaoTrofeusLiga[];
    historico: IDadosHistoricoTrofeusLiga[];
    detalhes: IDadosTrofeusLigaDetalhes;

}

export interface IDadosClassificacaoTrofeusLiga {
    posicao: number;
    codigo_Usuario: number;
    nome_Usuario: string;
    foto_Usuario: string;
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    quantidade_Titulo_Liga: number;
    quantidade_Titulo_Conferencia: number;
    quantidade_Titulo_Divisao: number;
}


export interface IDadosHistoricoTrofeusLiga {
    codigo_Liga: number;
    nome_Liga: string;
    codigo_Temporada: number;
    descricao_Temporada: string;
    logo_Franquia_Campea_Liga: string;
    franquia_Campea_Liga: string;
    codigo_Franquia_Campea_Liga: number
    codigo_Franquia_Campea_Conferencia: number;
    franquia_Campea_Conferencia: string;
    logo_franquia_Campea_Conferencia: string;
    franquia_Campea_Divisao: IDadosTrofeusLigaFranquias[],
}

export interface IDadosTrofeusLigaFranquias {
    codigo: number;
    nome: string;
    logo: string;
    caminho_Logo: string;
}

export interface IDadosTrofeusLigaDetalhes {
    detalhes_Conferencia: IFranquiaTituloDetalhesConferencia;
    detalhes_Divisao: IDadosTitulosDivisao[];
}

export interface IFranquiaTituloDetalhesConferencia {
    codigo_Primeiro_Conferencia: number;
    nome_Primeira_Conferencia: string;
    quantidade_Titulo_Primeira_Conferencia: number;
    codigo_Segunda_Conferencia: number;
    nome_Segunda_Conferencia: string;
    quantidade_Titulo_Segunda_Conferencia: number;
    titulos_Conferencia: ITitulosResumidoConferencia[];
}

export interface ITitulosResumidoConferencia {
    codigo_Temporada: number;
    descricao_Temporada: number;
    codigo: number;
    nome: string;
    logo: string;
    codigo_Conferencia: number;
    nome_Conferencia: string;
    codigo_Divisao: number;
    nome_Divisao: string;


}

export interface IDadosTitulosDivisao {
    codigo: number;
    nome: string;
    quantidade_Titulo_Liga: number;
    quantidade_Titulo_Conferencia: number;
    quantidade_Titulo_Copinha: number;
    franquias_Divisao: IDadosClassificacaoTrofeusLiga[];
}

export interface IDadosRetornoPowerRanking {
    dado: IListaDadosPowerRankingFranquia[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosPowerRankingFranquia {
    codigo: number;
    nome: string;
    logo: string
    peso: number;
    posicao: number;
}

export interface IDadosRetornoJogadoresPowerRanking {
    dado: IListaDadosJogadoresPowerRanking[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosJogadoresPowerRanking {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min: number;
    mplu?: number
    oreb?: number;
    pf?: number;
    pts?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    ordem: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    quantidade_Jogos?: number;
    fgM_Informativo?: number;
    fgA_Informativo?: number;
    ftM_Informativo?: number;
    ftA_Informativo?: number;
    threepM_Informativo?: number;
    threepA_Informativo?: number;
    peso_Total_Jogador?: number;
    setimo_Homem: boolean;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
}

export interface IDadosRetornoMapaCalor {
    dado: IListaDadosMapaCalor[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosMapaCalor {
    codigo: number;
    nome: string;
    logo: string;
    informacoes_Rodada: IDadosInformacoesRodada[];
    rodada: number[];
    vitoria: boolean[];
    empate: boolean[];
    derrota: boolean[];
}


export interface IDadosInformacoesRodada {
    codigo_Franquia: number;
    rodada: number;
    vitoria: boolean;
    empate: boolean;
    derrota: boolean;
}

export interface IDadosClassificacaoHistoricaFinal {
    codigo?: number;
    nome: string;
    logo: string
    vitoria: number;
    empate: number;
    derrota: number;
    aproveitamento: string;
}

export interface IDadosClassificacaoHistorica {
    codigo?: number;
    nome: string;
    logo?: string;
    foto?: string;
    codigo_Conferencia?: number;
    classificacao: IDadosClassificacaoHistoricaFinal[];
}

export interface IDadosRetornoClassificacoesHistorica {
    geral: IDadosClassificacaoHistorica;
    conferencia: IDadosClassificacaoHistorica[];
    divisao: IDadosClassificacaoHistorica[];

}

export interface IDadosRetornoClassificacaoHistorica {
    dado: IDadosRetornoClassificacoesHistorica;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


export interface IDadosRetornoJogadoresLideres {
    dado: IDadosJogadoresLideres;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosJogadoresLideres {
    codigo_Stats: number;
    sigla_Stats: string;
    nome_Stats: string;
    codigo_Liga: number;
    nome_Liga: string;
    logo_Liga: string;
    codigo_Temporada: number;
    descricao_Temporada: string;
    jogador_Stats_Total: IDetalheJogadorLider[];
    jogador_Stats_Jogo: IDetalheJogadorLider[];
}

export interface IDetalheJogadorLider {
    posicao: number;
    codigo_Jogador: number;
    nome_Jogador: string;
    foto_Jogador: string;
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    valor_Stats: string;

}

export interface IDadosRetornoFranquiasLideres {
    dado: IDadosFranquiasLideres;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosFranquiasLideres {
    codigo_Stats: number;
    sigla_Stats: string;
    nome_Stats: string;
    codigo_Liga: number;
    nome_Liga: string;
    logo_Liga: string;
    codigo_Temporada: number;
    descricao_Temporada: string;
    franquia_Stats: IDetalheFranquiaLider[];
}

export interface IDetalheFranquiaLider {
    posicao: number;
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    valor_Stats_Total: string;
    quantidade_Jogos: number;
    valor_Stats_Jogo: string;
    valor_Stats_Jogador: string;
}

export interface IDadosRetornoTimeVersusRodada {
    dado: IDadosRetornoFranquiaVersusRodada;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoFranquiaVersusRodada {
    franquia: IDadosTimeVersusRodada;
    franquias_Liga: IDadosTimeVersusRodada[];
    classificacao_Franquia: IDadosTimeVersusRodada;

}

export interface IDadosTimeVersusRodada {
    codigo?: number;
    codigo_NBA?: number;
    nome?: string;
    foto?: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem?: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fgM_Informativo?: number;
    fgA_Informativo?: number;
    ftM_Informativo?: number;
    ftA_Informativo?: number;
    threepM_Informativo?: number;
    threepA_Informativo?: number;
    setimo_Homem?: boolean;
    placar?: string;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
}

export interface IRetornoMelhoresJogadoresPorPosicao {
    dado: IDadosMelhoresJogadoresPorPosicao;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosMelhoresJogadoresPorPosicao {
    premiacao: IDadosPontuacaoMelhoresJogadores[];
    first_Time: IDadosPontuacaoMelhoresJogadores[];
    second_Time: IDadosPontuacaoMelhoresJogadores[];
    first_Time_Rookie: IDadosPontuacaoMelhoresJogadores[];
    second_Time_Rookie: IDadosPontuacaoMelhoresJogadores[];
    first_Time_Dpoy: IDadosPontuacaoMelhoresJogadores[];
    second_Time_Dpoy: IDadosPontuacaoMelhoresJogadores[];

}

export interface IDadosPontuacaoMelhoresJogadores {
    codigo?: number;
    codigo_Liga?: number;
    codigo_Franquia?: number;
    codigo_NBA?: number;
    nome_Premiacao?: string;
    nome?: string;
    foto?: string;
    posicao?: string;
    posicao_Original?: string;
    arremessos?: number;
    arremessos_Errados?: number;
    arremessos_Tentativas?: number;
    lance_Livre?: number;
    lance_Livre_Errados?: number;
    lance_Livre_Tentativas?: number;
    tres_Pontos?: number;
    tres_Pontos_Errados?: number;
    tres_Pontos_Tentativas?: number;
    pontos?: number;
    rebotes?: number
    ordem?: number;
    rebotes_Ofensivos?: number;
    peso_Total?: number;
    rebotes_Defensivos?: number;
    assistencias?: number;
    quantidade_Jogos?: number;
    bloqueios?: number;
    steal?: number;
    faltas?: number;
    minutos?: number;
    min_Plus?: number;
    turnovers?: number;
    stocks?: number;
    porcentagem_Arremessos?: number;
    porcentagem_Lance_Livre?: number;
    porcentagem_Tres_Pontos?: number;
    peso_Total_Defesa?: number;
    salario?: number;
    nome_Franquia_Liga?: string;
    tempo_Contrato?: number;
    codigo_Franquia_Liga?: number;
    logo_Franquia_Liga: string;
    caminho_Logo_Franquia_Liga: string;
    codigo_Franquia_NBA?: number;
    nome_Franquia_NBA: string;
    logo_Franquia_NBA: string;
    codigo_Temporada_Calouro: number;
}


export interface IRetornoRecordes {
    dado: IRetornoDadosRecordes;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IRetornoDadosRecordes {
    recordes_Liga: IDadosRecordes[];
    recordes_Site: IDadosRecordes[];
}

export interface IDadosRecordes {
    codigo?: number;
    codigo_Liga?: number;
    codigo_Franquia?: number;
    codigo_Usuario?: number;
    codigo_Calendario?: number;
    sequencia_Vitorias?: number;
    nome_Liga: string;
    logo_Liga: string;
    descricao_Temporada: string;
    nome_Franquia: string;
    logo_Franquia: string;
    nome_Usuario: string;
    foto_Usuario: string;
    codigo_NBA?: number;
    nome_Premiacao?: string;
    posicao?: string;
    posicao_Original?: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min: number;
    mplu?: number
    oreb?: number;
    pf?: number;
    pts?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    ordem: number;
    posicao_Liga?: string;
    quantidade_Jogos?: number;
    fgM_Informativo?: number;
    fgA_Informativo?: number;
    ftM_Informativo?: number;
    ftA_Informativo?: number;
    threepM_Informativo?: number;
    threepA_Informativo?: number;
    peso_Total_Jogador?: number;
    setimo_Homem: boolean;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
}

export interface IRetornoClassificacoesNBA {
    dado: IRetornoDadosClassificacaoNBA;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IRetornoDadosClassificacaoNBA {
    classificacao_Conferencia: IRetornoClassificacaoConferencia
    classificacao_Stats: IRetornoClassificacaoStats
}

export interface IRetornoClassificacaoConferencia {  
    conferencia_Leste: IDadosResumidoClassificacoesNBA[];
    conferencia_Oeste: IDadosResumidoClassificacoesNBA[];
}

export interface IRetornoClassificacaoStats {
    jogo: IDadosClassificacoesNBA[];
    total: IDadosClassificacoesNBA[];
}
export interface IDadosClassificacoesNBA {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    conferencia: string;
    jogos: number;
    vitoria: number;
    derrota: number;
    aproveitamento: number;
    fgm: number;
    fge: number;
    fG_Tentativa: number;
    fG_Porcentagem: string;
    ftm: number;
    fte: number;
    fT_Tentativa: number;
    fT_Porcentagem: string;
    dois_Pontos: number;
    dois_Pontos_Errado: number;
    dois_Pontos_Tentativa: number;
    dois_Pontos_Porcentagem: string;
    tres_Pontos: number;
    tres_Pontos_Errado: number;
    tres_Pontos_Tentativa: number;
    tres_Pontos_Porcentagem: string;
    pontos: number;
    rebotes: number;
    rebote_Ofensivo: number;
    rebote_Defensivo: number;
    assistencia: number;
    steal: number;
    bloqueio: number;
    turnovers: number;
    faltas: number;
    min_Plus: number | null;
    minutos: number;
    stocks: number;  
    total_Rebote: number;
    dtCriacao: string;
    codUsuCriacao: number;
    dtModificacao: string;
    codUsuModificacao: number;
    dtDelecao: string;
    codUsuDelecao: number;
    deletado: boolean;
    posicao: number;
}

export interface IDadosResumidoClassificacoesNBA {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    conferencia: string;
    jogos: number;
    vitoria: number;
    derrota: number;
    aproveitamento: number;
    dtCriacao: string;
    codUsuCriacao: number;
    dtModificacao: string;
    codUsuModificacao: number;
    dtDelecao: string;
    codUsuDelecao: number;
    deletado: boolean;
}



const getStatsJogadoresLideres = async (codigoLiga: number, codigoTemporada: number, codigoStats: number): Promise<IDadosRetornoJogadoresLideres> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresLideres>(`/estatistica/lider/stats/jogador/${codigoLiga}/${codigoTemporada}/${codigoStats}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getStatsFranquiasLideres = async (codigoLiga: number, codigoTemporada: number, codigoStats: number): Promise<IDadosRetornoFranquiasLideres> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFranquiasLideres>(`/estatistica/lider/stats/franquia/${codigoLiga}/${codigoTemporada}/${codigoStats}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getMediaTimes = async (codigoLiga: number, codigoTemporada: number, qtdJogos: number, tipo: number): Promise<IDadosRetornoMediaTimes> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoMediaTimes>(`/estatistica/time/liga/media/${codigoLiga}/${codigoTemporada}/${qtdJogos}/${tipo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

export interface IDadosFiltrosJogadores {
    codigoLiga: number;
    codigoTemporada: number;
    codigoJogador?: number | null;
    codigoFranquiaLiga?: number | null;
    codigoFranquiaNBA?: number | null;
    posicao?: string | null;
    dataInicio?: string | null;
    dataFim?: string | null;
    codigoTemporadaCalouro?: number | null;
    quantidadeDeJogos?: number | null;
    ast: boolean;
    peso_AST?: number | null;
    blk: boolean;
    peso_BLK?: number | null;
    pf: boolean;
    peso_PF?: number | null;
    fgm: boolean;
    peso_FGM?: number | null;
    fga: boolean;
    peso_FGA?: number | null;
    fge: boolean;
    peso_FGE?: number | null;
    ftm: boolean;
    peso_FTM?: number | null;
    fte: boolean;
    peso_FTE?: number | null;
    fta: boolean;
    peso_FTA?: number | null;
    mplu: boolean;
    peso_MPLU?: number | null;
    pts: boolean;
    peso_PTS?: number | null;
    reb: boolean;
    peso_REB?: number | null;
    dreb: boolean;
    peso_DREB?: number | null;
    oreb: boolean;
    peso_OREB?: number | null;
    stl: boolean;
    peso_STL?: number | null;
    threepm: boolean;
    peso_THREEPM?: number | null;
    threepe: boolean;
    peso_THREEPE?: number | null;
    threepa: boolean;
    peso_THREEPA?: number | null;
    tor: boolean;
    peso_TO?: number | null;
    stocks: boolean;
    peso_STOCKS?: number | null;
    fgmp: boolean;
    peso_FGMP?: number | null;
    ftmp: boolean;
    peso_FTMP?: number | null;
    threepmp: boolean;
    peso_THREEPMP?: number | null;
}

// export interface IDadosConsultaRecordes {
//     codigo_Liga: number;
//     codigo_Temporada: number;
//     codigo_Franquia?: number;
//     codigo_Stats?: number;
// }

const getMediaJogadores = async (dadosFiltros: IDadosFiltrosJogadores): Promise<IDadosRetornoMediaJogadores> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoMediaJogadores>(`/estatistica/jogador/liga/media`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo: dadosFiltros.codigoJogador,
            codigo_Liga: dadosFiltros.codigoLiga,
            codigo_Temporada: dadosFiltros.codigoTemporada,
            codigo_Franquia_Liga: dadosFiltros.codigoFranquiaLiga,
            codigo_Franquia_NBA: dadosFiltros.codigoFranquiaNBA,
            posicao: dadosFiltros.posicao,
            data_Inicio: dadosFiltros.dataInicio,
            data_Fim: dadosFiltros.dataFim,
            codigo_Temporada_Calouro: dadosFiltros.codigoTemporadaCalouro,
            quantidade_Jogos: dadosFiltros.quantidadeDeJogos,
            ast: dadosFiltros.ast,
            peso_AST: dadosFiltros.peso_AST,
            blk: dadosFiltros.blk,
            peso_BLK: dadosFiltros.peso_BLK,
            pf: dadosFiltros.pf,
            peso_PF: dadosFiltros.peso_PF,
            fgm: dadosFiltros.fgm,
            peso_FGM: dadosFiltros.peso_FGM,
            fga: dadosFiltros.fga,
            peso_FGA: dadosFiltros.peso_FGA,
            fge: dadosFiltros.fge,
            peso_FGE: dadosFiltros.peso_FGE,
            ftm: dadosFiltros.ftm,
            peso_FTM: dadosFiltros.peso_FTM,
            fte: dadosFiltros.fte,
            peso_FTE: dadosFiltros.peso_FTE,
            fta: dadosFiltros.fta,
            peso_FTA: dadosFiltros.peso_FTA,
            mplu: dadosFiltros.mplu,
            peso_MPLU: dadosFiltros.peso_MPLU,
            pts: dadosFiltros.pts,
            peso_PTS: dadosFiltros.peso_PTS,
            reb: dadosFiltros.reb,
            peso_REB: dadosFiltros.peso_REB,
            dreb: dadosFiltros.dreb,
            peso_DREB: dadosFiltros.peso_DREB,
            oreb: dadosFiltros.oreb,
            peso_OREB: dadosFiltros.peso_OREB,
            stl: dadosFiltros.stl,
            peso_STL: dadosFiltros.peso_STL,
            threepm: dadosFiltros.threepm,
            peso_THREEPM: dadosFiltros.peso_THREEPM,
            threepe: dadosFiltros.threepe,
            peso_THREEPE: dadosFiltros.peso_THREEPE,
            threepa: dadosFiltros.threepa,
            peso_THREEPA: dadosFiltros.peso_THREEPA,
            to: dadosFiltros.tor,
            peso_TO: dadosFiltros.peso_TO,
            stocks: dadosFiltros.stocks,
            peso_STOCKS: dadosFiltros.peso_STOCKS,
            fgmp: dadosFiltros.fgmp,
            peso_FGMP: dadosFiltros.peso_FGMP,
            ftmp: dadosFiltros.ftmp,
            peso_FTMP: dadosFiltros.peso_FTMP,
            threepmp: dadosFiltros.threepmp,
            peso_THREEPMP: dadosFiltros.peso_THREEPMP,
        }

    });
    return data;
}

const getMediaJogadoresNBA = async (dadosFiltros: IDadosFiltrosJogadores): Promise<IDadosRetornoMediaJogadores> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoMediaJogadores>(`/estatistica/jogador/nba/media`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo: dadosFiltros.codigoJogador,
            codigo_Liga: dadosFiltros.codigoLiga,
            codigo_Temporada: dadosFiltros.codigoTemporada,
            codigo_Franquia_Liga: dadosFiltros.codigoFranquiaLiga,
            codigo_Franquia_NBA: dadosFiltros.codigoFranquiaNBA,
            posicao: dadosFiltros.posicao,
            data_Inicio: dadosFiltros.dataInicio,
            data_Fim: dadosFiltros.dataFim,
            codigo_Temporada_Calouro: dadosFiltros.codigoTemporadaCalouro,
            quantidade_Jogos: dadosFiltros.quantidadeDeJogos,
            ast: dadosFiltros.ast,
            peso_AST: dadosFiltros.peso_AST,
            blk: dadosFiltros.blk,
            peso_BLK: dadosFiltros.peso_BLK,
            pf: dadosFiltros.pf,
            peso_PF: dadosFiltros.peso_PF,
            fgm: dadosFiltros.fgm,
            peso_FGM: dadosFiltros.peso_FGM,
            fga: dadosFiltros.fga,
            peso_FGA: dadosFiltros.peso_FGA,
            fge: dadosFiltros.fge,
            peso_FGE: dadosFiltros.peso_FGE,
            ftm: dadosFiltros.ftm,
            peso_FTM: dadosFiltros.peso_FTM,
            fte: dadosFiltros.fte,
            peso_FTE: dadosFiltros.peso_FTE,
            fta: dadosFiltros.fta,
            peso_FTA: dadosFiltros.peso_FTA,
            mplu: dadosFiltros.mplu,
            peso_MPLU: dadosFiltros.peso_MPLU,
            pts: dadosFiltros.pts,
            peso_PTS: dadosFiltros.peso_PTS,
            reb: dadosFiltros.reb,
            peso_REB: dadosFiltros.peso_REB,
            dreb: dadosFiltros.dreb,
            peso_DREB: dadosFiltros.peso_DREB,
            oreb: dadosFiltros.oreb,
            peso_OREB: dadosFiltros.peso_OREB,
            stl: dadosFiltros.stl,
            peso_STL: dadosFiltros.peso_STL,
            threepm: dadosFiltros.threepm,
            peso_THREEPM: dadosFiltros.peso_THREEPM,
            threepe: dadosFiltros.threepe,
            peso_THREEPE: dadosFiltros.peso_THREEPE,
            threepa: dadosFiltros.threepa,
            peso_THREEPA: dadosFiltros.peso_THREEPA,
            to: dadosFiltros.tor,
            peso_TO: dadosFiltros.peso_TO,
            stocks: dadosFiltros.stocks,
            peso_STOCKS: dadosFiltros.peso_STOCKS,
            fgmp: dadosFiltros.fgmp,
            peso_FGMP: dadosFiltros.peso_FGMP,
            ftmp: dadosFiltros.ftmp,
            peso_FTMP: dadosFiltros.peso_FTMP,
            threepmp: dadosFiltros.threepmp,
            peso_THREEPMP: dadosFiltros.peso_THREEPMP,
        }
    });
    return data;
}

const getMeusJogadores = async (codigoFranquia: number, codigoTemporada: number, qtdJogos: number): Promise<IDadosRetornoMeusJogadores> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoMeusJogadores>(`/estatistica/jogador/media/${codigoFranquia}/${codigoTemporada}/${qtdJogos}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getJogadoresTodos = async (codigoLiga: number, codigoTemporada: number, qtdJogos: number): Promise<IDadosRetornoMeusJogadores> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoMeusJogadores>(`/estatistica/jogador/media/todos/${codigoLiga}/${codigoTemporada}/${qtdJogos}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getTimeVersus = async (codigoLiga: number, codigoFranquia: number, codigoTemporada: number, qtdJogos: number): Promise<IDadosRetornoTimeVersus> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoTimeVersus>(`/estatistica/time/versus/${codigoFranquia}/${codigoTemporada}/${qtdJogos}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getHistoricoConfrontosLiga = async (codigoFranquia1: number, codigoFranquia2: number, codigoTemporada: number, tipoConfronto: number): Promise<IDadosRetornoHistoricoConfrontosFranquias> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoHistoricoConfrontosFranquias>(`/estatistica/confronto/liga/${codigoFranquia1}/${codigoFranquia2}/${codigoTemporada}/${tipoConfronto}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getHistoricoConfrontosUsuario = async (codigoUsuario1: number, codigoUsuario2: number, codigoTemporada: number, tipoConfronto: number): Promise<IDadosRetornoHistoricoConfrontos> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoHistoricoConfrontos>(`/estatistica/confronto/usuario/${codigoUsuario1}/${codigoUsuario2}/${codigoTemporada}/${tipoConfronto}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getTrofeusGM = async (codigoUsuario: number = 0): Promise<IDadosRetornoTrofeusGM> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoTrofeusGM>(`/estatistica/trofeus/usuario/${codigoUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getGaleriaGM = async (codigoUsuario: number): Promise<IDadosRetornoGaleriaGM> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoGaleriaGM>(`/estatistica/trofeus/usuario/detalhes/${codigoUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getTrofeusLiga = async (codigoLiga: number = 0): Promise<IDadosRetornoTrofeusLiga> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoTrofeusLiga>(`/estatistica/trofeus/liga/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getJogadoresPowerRanking = async (codigoFranquia: number, tipoFiltro: number): Promise<IDadosRetornoJogadoresPowerRanking> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresPowerRanking>(`/estatistica/time/power/detalhes/${codigoFranquia}/${tipoFiltro}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getPowerRanking = async (codigoLiga: number, tipoFiltro: number): Promise<IDadosRetornoPowerRanking> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoPowerRanking>(`/estatistica/time/power/${codigoLiga}/${tipoFiltro}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosMapaCalor = async (codigoLiga: number, codigoTemporada: number): Promise<IDadosRetornoMapaCalor> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoMapaCalor>(`estatistica/time/rodada/historico/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getClassificacaoHistoricaFranquiaPorCodigoLiga = async (codigoLiga: number, codigoTemporada: number = 0): Promise<IDadosRetornoClassificacaoHistorica> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoClassificacaoHistorica>(`estatistica/franquia/classificacao/historica/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getClassificacaoHistoricaUsuarioPorCodigoLiga = async (codigoLiga: number, codigoTemporada: number = 0): Promise<IDadosRetornoClassificacaoHistorica> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoClassificacaoHistorica>(`estatistica/usuario/classificacao/historica/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getTimePorRodadas = async (codigoFranquia: number, codigoTemporada: number, rodada: number): Promise<IDadosRetornoTimeVersusRodada> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoTimeVersusRodada>(`/estatistica/time/versus/rodada/${codigoFranquia}/${codigoTemporada}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getMelhoresJogadores = async (codigoLiga: number, codigoTemporada: number, numeroJogos: number): Promise<IRetornoMelhoresJogadoresPorPosicao> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IRetornoMelhoresJogadoresPorPosicao>(`/estatistica/jogador/melhores/${codigoLiga}/${codigoTemporada}/${numeroJogos}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getRecordes = async (codigoLiga: number, codigoTemporada: number, codigoFranquia: number, codigoStats: number): Promise<IRetornoRecordes> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IRetornoRecordes>(`/estatistica/franquia/recorde`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo_Liga: codigoLiga,
            codigo_Temporada: codigoTemporada > 0 ? codigoTemporada : null,
            codigo_Franquia: codigoFranquia > 0 ? codigoFranquia : null,
            codigo_Usuario: null,
            codigo_Stats: codigoStats > 0 ? codigoStats : null
        }
    });
    return data;
}

const getClassificacoesNBA = async (codigoTemporada: number): Promise<IRetornoClassificacoesNBA> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IRetornoClassificacoesNBA>(`/estatistica/classificacao/franquia/nba/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


export const EstatisticasService = {
    getMediaTimes,
    getTimeVersus,
    getMeusJogadores,
    getMediaJogadores,
    getMediaJogadoresNBA,
    getHistoricoConfrontosLiga,
    getHistoricoConfrontosUsuario,
    getTrofeusGM,
    getGaleriaGM,
    getTrofeusLiga,
    getPowerRanking,
    getJogadoresPowerRanking,
    getDadosMapaCalor,
    getClassificacaoHistoricaFranquiaPorCodigoLiga,
    getClassificacaoHistoricaUsuarioPorCodigoLiga,
    getStatsJogadoresLideres,
    getStatsFranquiasLideres,
    getTimePorRodadas,
    getMelhoresJogadores,
    getJogadoresTodos,
    getRecordes,
    getClassificacoesNBA

}